
// Dictionary mapping country name to its mobile code
const countryCodes = {
    "Afghanistan": "+93",
    "Åland Islands": "+358",
    "Albania": "+355",
    "Algeria": "+213",
    "Andorra": "+376",
    "Angola": "+244", 
    "Anguilla": "+1-264",
    "Antigua and Barbuda": "+1-268",
    "Argentina": "+54",
    "Armenia": "+374",
    "Aruba": "+297",
    "Ascension Island": "+247",
    "Australia": "+61",
    "Austria": "+43",
    "Azerbaijan": "+994",
    "Bahamas": "+1-242",
    "Bahrain": "+973",
    "Bangladesh": "+880",
    "Barbados": "+1-246",
    "Belarus": "+375",
    "Belgium": "+32",
    "Belize": "+501",
    "Benin": "+229",
    "Bermuda": "+1-441",
    "Bhutan": "+975",
    "Bolivia": "+591",
    "Bosnia and Herzegovina": "+387",
    "Botswana": "+267",
    "Brazil": "+55",
    "British Indian Ocean Territory": "+246",
    "British Virgin Islands": "+1-284",
    "Brunei": "+673",
    "Bulgaria": "+359",
    "Burkina Faso": "+226",
    "Burundi": "+257",
    "Cambodia": "+855",
    "Cameroon": "+237",
    "Canada": "+1",
    "Cape Verde": "+238",
    "Caribbean Netherlands": "+599",
    "Cayman Islands": "+1-345",
    "Central African Republic": "+236",
    "Chad": "+235",
    "Chile": "+56",
    "China": "+86",
    "Christmas Island": "+61",
    "Cocos (Keeling) Islands": "+61",
    "Colombia": "+57",
    "Comoros": "+269",
    "Congo (Brazzaville)": "+242",
    "Congo (Kinshasa)": "+243",
    "Cook Islands": "+682",
    "Costa Rica": "+506",
    "Croatia": "+385",
    "Curaçao": "+599",
    "Cyprus": "+357",
    "Czechia": "+420",
    "Côte d'Ivoire": "+225",
    "Denmark": "+45",
    "Djibouti": "+253",
    "Dominica": "+1-767",
    "Dominican Republic": "+1-809, +1-829, +1-849",
    "Ecuador": "+593",
    "Egypt": "+20",
    "El Salvador": "+503",
    "Equatorial Guinea": "+240",
    "Eritrea": "+291",
    "Estonia": "+372",
    "Eswatini": "+268",
    "Ethiopia": "+251",
    "Falkland Islands": "+500",
    "Faroe Islands": "+298",
    "Fiji": "+679",
    "Finland": "+358",
    "France": "+33",
    "French Guiana": "+594",
    "French Polynesia": "+689",
    "French Southern Territories": "+262",
    "Gabon": "+241",
    "Gambia": "+220",
    "Georgia": "+995",
    "Germany": "+49",
    "Ghana": "+233",
    "Gibraltar": "+350",
    "Greece": "+30",
    "Greenland": "+299",
    "Grenada": "+1-473",
    "Guadeloupe": "+590",
    "Guatemala": "+502",
    "Guernsey": "+44-1481",
    "Guinea": "+224",
    "Guinea-Bissau": "+245",
    "Guyana": "+592",
    "Haiti": "+509",
    "Honduras": "+504",
    "Hong Kong": "+852",
    "Hungary": "+36",
    "Iceland": "+354",
    "India": "+91",
    "Indonesia": "+62",
    "Iraq": "+964",
    "Ireland": "+353",
    "Isle of Man": "+44-1624",
    "Israel": "+972",
    "Italy": "+39",
    "Jamaica": "+1-876",
    "Japan": "+81",
    "Jersey": "+44-1534",
    "Jordan": "+962",
    "Kazakhstan": "+7",
    "Kenya": "+254",
    "Kiribati": "+686",
    "Kosovo": "+383",
    "Kuwait": "+965",
    "Kyrgyzstan": "+996",
    "Laos": "+856",
    "Latvia": "+371",
    "Lebanon": "+961",
    "Lesotho": "+266",
    "Liberia": "+231",
    "Libya": "+218",
    "Liechtenstein": "+423",
    "Lithuania": "+370",
    "Luxembourg": "+352",
    "Macao": "+853",
    "Madagascar": "+261",
    "Malawi": "+265",
    "Malaysia": "+60",
    "Maldives": "+960",
    "Mali": "+223",
    "Malta": "+356",
    "Martinique": "+596",
    "Mauritania": "+222",
    "Mauritius": "+230",
    "Mayotte": "+262",
    "Mexico": "+52",
    "Moldova": "+373",
    "Monaco": "+377",
    "Mongolia": "+976",
    "Montenegro": "+382",
    "Montserrat": "+1-664",
    "Morocco": "+212",
    "Mozambique": "+258",
    "Myanmar": "+95",
    "Namibia": "+264",
    "Nauru": "+674",
    "Nepal": "+977",
    "Netherlands": "+31",
    "New Caledonia": "+687",
    "New Zealand": "+64",
    "Nicaragua": "+505",
    "Niger": "+227",
    "Nigeria": "+234",
    "Niue": "+683",
    "Norfolk Island": "+672",
    "North Macedonia": "+389",
    "Norway": "+47",
    "Oman": "+968",
    "Pakistan": "+92",
    "Palestinian Territories": "+970",
    "Panama": "+507",
    "Papua New Guinea": "+675",
    "Paraguay": "+595",
    "Peru": "+51",
    "Philippines": "+63",
    "Pitcairn Islands": "+64",
    "Poland": "+48",
    "Portugal": "+351",
    "Qatar": "+974",
    "Réunion": "+262",
    "Romania": "+40",
    "Russia": "+7",
    "Rwanda": "+250",
    "Samoa": "+685",
    "San Marino": "+378",
    "São Tomé and Príncipe": "+239",
    "Saudi Arabia": "+966",
    "Senegal": "+221",
    "Serbia": "+381",
    "Seychelles": "+248",
    "Sierra Leone": "+232",
    "Singapore": "+65",
    "Sint Maarten": "+1-721",
    "Slovakia": "+421",
    "Slovenia": "+386",
    "Solomon Islands": "+677",
    "Somalia": "+252",
    "South Africa": "+27",
    "South Georgia and the South Sandwich Islands": "+500",
    "South Korea": "+82",
    "South Sudan": "+211",
    "Spain": "+34",
    "Sri Lanka": "+94",
    "St. Barthélemy": "+590",
    "St. Helena": "+290",
    "St. Kitts and Nevis": "+1-869",
    "St. Lucia": "+1-758",
    "St. Martin": "+590",
    "St. Pierre and Miquelon": "+508",
    "St. Vincent and the Grenadines": "+1-784",
    "Sudan": "+249",
    "Suriname": "+597",
    "Svalbard and Jan Mayen": "+47",
    "Sweden": "+46",
    "Switzerland": "+41",
    "Taiwan": "+886",
    "Tajikistan": "+992",
    "Tanzania": "+255",
    "Thailand": "+66",
    "Timor-Leste": "+670",
    "Togo": "+228",
    "Tokelau": "+690",
    "Tonga": "+676",
    "Trinidad and Tobago": "+1-868",
    "Tristan da Cunha": "+290",
    "Tunisia": "+216",
    "Turkey": "+90",
    "Turkmenistan": "+993",
    "Turks and Caicos Islands": "+1-649",
    "Tuvalu": "+688",
    "U.S. Outlying Islands": "+1-684",
    "Uganda": "+256",
    "Ukraine": "+380",
    "United Arab Emirates": "+971",
    "United Kingdom": "+44",
    "United States": "+1",
    "Uruguay": "+598",
    "Uzbekistan": "+998",
    "Vanuatu": "+678",
    "Vatican City": "+39-06",
    "Venezuela": "+58",
    "Vietnam": "+84",
    "Wallis and Futuna": "+681",
    "Western Sahara": "+212",
    "Yemen": "+967",
    "Zambia": "+260",
    "Zimbabwe": "+263"
}

document.querySelectorAll(".country-code--js").forEach(function (countryCodeEle) {
    const dataBlockId = countryCodeEle.getAttribute("data-block-id");
    const CountryCodeSelectInput = document.getElementById(`AddressTelCode--${dataBlockId}`);
    Object.keys(countryCodes).forEach(function (country) {
        const option = document.createElement("option");
        option.value = countryCodes[country];
        option.textContent = `${countryCodes[country]}`;
        CountryCodeSelectInput.appendChild(option);
    });
});

document.querySelectorAll('.on-change-select-country---js').forEach(function (customSelectCountry) {
    customSelectCountry.addEventListener('change', function (evt) {
        let blockID = customSelectCountry.getAttribute('data-block-id');
        const countrySelect = document.getElementById(`AddressCountryProduct--${blockID}`);
        const provinceSelect = document.getElementById(`AddressState--${blockID}`);
        const selectedValue = evt.target.value;
        const countryCodeSelectInput = document.getElementById(`AddressTelCode--${blockID}`);

        if (countryCodeSelectInput) {
            countryCodeSelectInput.value = countryCodes[selectedValue];
        }

        const provincesData = countrySelect.options[countrySelect.selectedIndex].dataset.provinces;
        const provinces = JSON.parse(provincesData);
        provinceSelect.innerHTML = '';
        if (provinces.length > 0) {
            document.getElementById(`AddressStateContainer--${blockID}`).style.display = 'block';
            provinces.forEach(([provinceName, provinceValue]) => {
                const option = document.createElement('option');
                option.value = provinceValue;
                option.textContent = provinceName;
                provinceSelect.appendChild(option);
            });
        } else {
            document.getElementById(`AddressStateContainer--${blockID}`).style.display = 'none';
        }
    });
});

window.addEventListener('DOMContentLoaded', (event) => {
    document.querySelectorAll('.on-change-select-country---js').forEach(function (selectCountryEle) {
        let blockID = selectCountryEle.getAttribute('data-block-id');
        let defaultCountry = selectCountryEle.getAttribute('data-default');
        const countrySelect = document.getElementById(`AddressCountryProduct--${blockID}`);
        if (countrySelect) {
            countrySelect.value = defaultCountry;
            const changeEvent = new Event('change', { bubbles: true });
            countrySelect.dispatchEvent(changeEvent);
        }
    });
});